import simple from './simple';
import advanced from './advanced';
import advancedEu from './eu';

export default{
    simple,
    advanced,
    advancedEu
};

